<template>
    <div class="countdown" :class="customClass">
        <span v-if="showDays && timeLeft.days > 0">{{ timeLeft.days }} gün </span>
        <span v-if="showHours">{{ padZero(timeLeft.hours) }}:</span>
        <span v-if="showMinutes">{{ padZero(timeLeft.minutes) }}:</span>
        <span v-if="showSeconds">{{ padZero(timeLeft.seconds) }}</span>
        <span v-if="expired && expiredText">{{ expiredText }}</span>
    </div>
</template>

<script>
export default {
    name: 'Countdown',
    props: {
        deadline: {
            type: [String, Date, Number],
            required: false,
            default: null
        },
        localStorageKey: {
            type: String,
            default: null
        },
        showDays: {
            type: Boolean,
            default: true
        },
        showHours: {
            type: Boolean,
            default: true
        },
        showMinutes: {
            type: Boolean,
            default: true
        },
        showSeconds: {
            type: Boolean,
            default: true
        },
        expiredText: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            timeLeft: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                difference: 0
            },
            expired: false,
            interval: null
        }
    },
    computed: {
        effectiveDeadline() {
            if (this.localStorageKey) {
                const stored = localStorage.getItem(this.localStorageKey)
                if (typeof stored === 'string') {
                    const parseStored = JSON.parse(stored)
                    if (parseStored && parseStored.expiry) {
                        return parseInt(parseStored.expiry)
                    } else if (parseStored && parseStored.value) {
                        return Date.now() + parseInt(parseStored.value)
                    }
                }
            }
            if (this.deadline) {
                return new Date(this.deadline).getTime()
            }
            return 0
        }
    },
    mounted() {
        this.startCountdown()
    },
    beforeDestroy() {
        this.stopCountdown()
    },
    methods: {
        startCountdown() {
            this.calculateTimeLeft()
            this.interval = setInterval(() => {
                this.calculateTimeLeft()
            }, 1000)
        },
        stopCountdown() {
            if (this.interval) {
                clearInterval(this.interval)
            }
        },
        calculateTimeLeft() {
            const deadline = this.effectiveDeadline;
            const now = Date.now();
            const difference = deadline - now;
            if (difference <= 0) {
                this.expired = true
                this.timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 }
                this.stopCountdown()
                this.$emit('expired')
                return
            }

            this.timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((difference % (1000 * 60)) / 1000),
                difference:difference
            }
        },
        padZero(num) {
            return num < 10 ? `0${num}` : num
        }
    }
}
</script>

<style scoped>
.countdown {
    display: inline-block;
}
</style>
